import { render } from "./slidetab.vue?vue&type=template&id=abb9e0e4"
import script from "./slidetab.vue?vue&type=script&lang=js"
export * from "./slidetab.vue?vue&type=script&lang=js"

import exportComponent from "/home/metabrain/withyou/djvue/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__